import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift =
  reactQueryFetcherAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUplift,
    (
      signal: AbortSignal,
      {
        appGroupId,
        dsaId,
        dimension,
        reportDt,
      }: GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftParams
    ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult> => {
      return fetch(
        `/decisioning_studio_agents/${appGroupId}/${dsaId}/insights/personalization_explainer/${dimension}/uplift`,
        "GET",
        { report_dt: reportDt },
        { signal },
        { propagateFetchRequestError: false }
      );
    },
    isGetDecisioningStudioAgentsAppGroupIdDsaIdInsightsPersonalizationExplainerDimensionUpliftResult
  );
